export default __webpack_public_path__ + "static/650-660-670-680-65a14215109a6167ac10a598a2d41f59.jpg";